export default __webpack_public_path__ + "static/media/team_main_img.0e154596.png";